import z from 'zod';

export const brandSelectSchema = z.object({
  id: z.string().uuid({ message: 'Invalid brand ID format' }),
  name: z.string().min(1, { message: 'Brand name cannot be empty' }),
});

export const doctorDataSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  fullName: z.string().min(1, { message: 'Full name cannot be empty' }),
  webpage: z.string().url({ message: 'Invalid webpage URL' }),
  specialty: z.string(),
  email: z.string().email({ message: 'Invalid email format' }),
  phone: z.string(),
  status: z.enum(['active', 'inactive', 'on-leave', 'retired'], {
    message: 'Invalid status',
  }),
  brand: brandSelectSchema,
});

export const doctorDataCreateSchema = doctorDataSchema.omit({ id: true });

export type DoctorStatus = z.infer<typeof doctorDataSchema>['status'];

export type DoctorData = z.infer<typeof doctorDataSchema>;
export type BrandSelectData = z.infer<typeof brandSelectSchema>;
export type DoctorDataCreate = Omit<DoctorData, 'id'>;
